"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var useDetectOutsideClick_1 = require("../hooks/useDetectOutsideClick");
var lodash_1 = __importDefault(require("lodash"));
var ArrowIcon_1 = __importDefault(require("./Mobile/AccountDropDown/ArrowIcon"));
var classnames_1 = __importDefault(require("classnames"));
var Dropdown = function (_a) {
    var list = _a.list, selected = _a.selected, onChange = _a.onChange, _b = _a.itemKey, itemKey = _b === void 0 ? '' : _b, _c = _a.itemValue, itemValue = _c === void 0 ? '' : _c, itemTemplate = _a.itemTemplate, _d = _a.classList, classList = _d === void 0 ? '' : _d, _e = _a.hasCustomIcon, hasCustomIcon = _e === void 0 ? false : _e;
    var dropdownRef = react_1.useRef(null);
    var _f = useDetectOutsideClick_1.useDetectOutsideClick(dropdownRef, false), isActive = _f[0], setIsActive = _f[1];
    var _g = react_1.useState(false), isSelected = _g[0], setIsSelected = _g[1];
    var listItems = [];
    var selectedItemText = '';
    list.forEach(function (elem) {
        if (typeof elem === 'string') {
            if (elem === selected) {
                selectedItemText = selected;
            }
            else {
                listItems.push(elem);
            }
        }
        if (typeof elem === 'object') {
            if (elem[itemKey] === selected) {
                selectedItemText = elem[itemValue];
            }
            else {
                listItems.push(elem);
            }
        }
        if (elem[itemKey] === selected && itemTemplate) {
            selectedItemText = itemTemplate(elem);
        }
    });
    // @TODO implement Objet list and custom render tpl
    var itemList = function () {
        return listItems.map(function (elem, idx) {
            var idKey = typeof elem === 'string' ? idx : elem[itemKey];
            var itemInner = typeof elem === 'string' ? elem : elem[itemValue];
            if (itemTemplate) {
                itemInner = itemTemplate(elem, idx);
            }
            return (react_1.default.createElement("li", { onClick: function () {
                    lodash_1.default.isFunction(onChange) && onChange(idKey);
                    setIsSelected(true);
                }, key: elem[itemKey] }, itemInner));
        });
    };
    var toggleDropdown = function () { return setIsActive(!isActive); };
    return (react_1.default.createElement("div", { ref: dropdownRef, onClick: toggleDropdown, className: classnames_1.default('cm-dropdown', classList, {
            opened: isActive,
        }) },
        react_1.default.createElement("div", { className: classnames_1.default('selected', {
                'selected-option': isSelected,
            }) },
            selectedItemText,
            hasCustomIcon && react_1.default.createElement(ArrowIcon_1.default, { active: isActive })),
        isActive && react_1.default.createElement("ul", null, itemList())));
};
exports.default = Dropdown;
